import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeTipoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeTipoCompraConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeExercicioContratoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeNumeroContratoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeObjetoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeNomeContratadoContratoConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeStatusConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeDataValidadeInicialConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    removeDataValidadeFinalConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    setMostraAplicarFiltroConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    limpaFiltroConsultaPrestadoresServicosEmpresasTerceirizadas: [],
    aplicarFiltroConsultaPrestadoresServicosEmpresasTerceirizadas: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    tipoCompra: '',
    exercicioContrato: '',
    numeroContrato: '',
    objetoContrato: '',
    nomeContratadoContrato: '',
    dataValidadeInicial: '',
    dataValidadeFinal: '',
    status: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoContrato = (state = INITIAL_STATE, action) => {
    state.tipoContrato.splice(state.tipoContrato.indexOf(action.tipoContrato), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipoContrato = Array.from(state.tipoContrato)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: '', mostraAplicarFiltro: true }
}

const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}

const removeNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: '', mostraAplicarFiltro: true }
}

const removeObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: '', mostraAplicarFiltro: true }
}

const removeNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: '', mostraAplicarFiltro: true }
}

const removeDataValidadeInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeInicial: '', mostraAplicarFiltro: true }
}

const removeDataValidadeFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeFinal: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeAdministracao,
    [Types.REMOVE_TIPO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeTipoContrato,
    [Types.REMOVE_EXERCICIO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeExercicioContrato,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeTipoCompra,
    [Types.REMOVE_NUMERO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeNumeroContrato,
    [Types.REMOVE_OBJETO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeObjetoContrato,
    [Types.REMOVE_DATA_VALIDADE_INICIAL_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeDataValidadeInicial,
    [Types.REMOVE_DATA_VALIDADE_FINAL_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeDataValidadeFinal,
    [Types.REMOVE_NOME_CONTRATADO_CONTRATO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeNomeContratadoContrato,
    [Types.REMOVE_STATUS_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: removeStatus,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS]: aplicarFiltro,
})
